import * as _ from "lodash";
import {Button} from "../../models/formio/button";
import {CheckBox} from "../../models/formio/checkbox";
import {Classification} from "../../models/formio/classification";
import {Columns} from "../../models/formio/columns";
import {ComplexDataGrid} from "../../models/formio/complex-datagrid";
import {Content} from "../../models/formio/content";
import {Currency} from "../../models/formio/currency";
import {DataGrid} from "../../models/formio/data-grid";
import {DateTime} from "../../models/formio/datetime";
import {Day} from "../../models/formio/day";
import {EditGrid} from "../../models/formio/edit-grid";
import {Email} from "../../models/formio/email";
import {FileUpload} from "../../models/formio/file-upload";
import {FormioBase} from "../../models/formio/formiobase";
import { HiddenField } from "../../models/formio/hiddenfield";
import {Htmlelement} from "../../models/formio/htmlelement";
import {MyEcoActivity} from "../../models/formio/my-eco-activity";
import {MyContent} from "../../models/formio/mycontent";
import {Number} from "../../models/formio/number";
import {Phone} from "../../models/formio/phone";
import {Radio} from "../../models/formio/radio";
import {Select} from "../../models/formio/select";
import {Table} from "../../models/formio/table";
import {TextArea} from "../../models/formio/textarea";
import {TextField} from "../../models/formio/textfield";

export default class FormUtils {

  public static convertToComponent(field: FormioBase) {
    switch (true) {
      case ("checkbox" === field.inputType):
        return new CheckBox();
      case ("text" === field.inputType):
        return new TextField();
      case ("textarea" === field.inputType):
        return new TextArea();
      case ("number" === field.inputType):
        // eslint-disable-next-line
        return new Number();
      case ("day" === field.inputType):
        return new Day();
      case ("datetime" === field.inputType):
        return new DateTime();
      case ("content" === field.inputType):
        return new Content();
      case ("mycontent" === field.inputType):
        return new MyContent();
      case ("select" === field.inputType):
        return new Select();
      case ("radio" === field.inputType):
        return new Radio();
      case ("file" === field.inputType):
        return new FileUpload();
      case ("datagrid" === field.inputType):
        return new DataGrid();
      case ("editgrid" === field.inputType):
        return new EditGrid();
      case ("complexdatagrid" === field.inputType):
        return new ComplexDataGrid();
      case ("myecoactivity" === field.inputType):
        return new MyEcoActivity();
      case ("email" === field.inputType):
        return new Email();
      case ("currency" === field.inputType):
        return new Currency();
      case ("phoneNumber" === field.inputType):
        return new Phone();
      case ("classification" === field.inputType):
        return new Classification();
      case ("table" === field.inputType):
        return new Table();
      case ("htmlelement" === field.inputType):
        return new Htmlelement();
      case ("columns" === field.inputType):
        return new Columns();
      case ("button" === field.inputType):
        return new Button();
      case ("hidden" === field.inputType):
        return new HiddenField();
      default:
        return undefined;
    }
  }

  public static getIcon(field: FormioBase) {
    switch (true) {
      case ("checkbox" === field.inputType):
        return new CheckBox().icon;
      case ("text" === field.inputType):
        return new TextField().icon;
      case ("textarea" === field.inputType):
        return new TextArea();
      case ("number" === field.inputType):
        // eslint-disable-next-line
        return new Number().icon;
      case ("day" === field.inputType):
        return new Day().icon;
      case ("datetime" === field.inputType):
        return new DateTime().icon;
      case ("content" === field.inputType):
        return new Content().icon;
      case ("mycontent" === field.inputType):
        return new MyContent().icon;
      case ("select" === field.inputType):
        return new Select().icon;
      case ("radio" === field.inputType):
        return new Radio().icon;
      case ("file" === field.inputType):
        return new FileUpload().icon;
      case ("datagrid" === field.inputType):
        return new DataGrid().icon;
      case ("editgrid" === field.inputType):
        return new EditGrid().icon;
      case ("complexdatagrid" === field.inputType):
        return new ComplexDataGrid().icon;
      case ("myecoactivity" === field.inputType):
        return new MyEcoActivity().icon;
      case ("email" === field.inputType):
        return new Email().icon;
      case ("currency" === field.inputType):
        return new Currency().icon;
      case ("phoneNumber" === field.inputType):
        return new Phone().icon;
      case ("classification" === field.inputType):
        return new Classification().icon;
      case ("table" === field.inputType):
        return new Table().icon;
      case ("htmlelement" === field.inputType):
        return new Htmlelement().icon;
      case ("columns" === field.inputType):
        return new Columns().icon;
      case ("button" === field.inputType):
        return new Button().icon;
      case ("hidden" === field.inputType):
        return new HiddenField().icon;
      default:
        return undefined;
    }
  }

  public static convertDeterminantTypeToFieldType(type: string) {
    if (type === "BOOLEAN") {
      return "boolean";
    } else if (type === "NUMERIC") {
      return "number";
    } else if (type === "SELECTION") {
      return "select";
    } else if (type === "RADIO") {
      return "radio";
    } else if (type === "DATE") {
      return "datetime";
    } else if (type === "CLASSIFICATION" || type === "SUB_CATALOG") {
      return "classification";
    } else if (type === "TEXT") {
      return "text";
    } else if (type === "MONEY") {
      return "number";
    } else {
      return "";
    }
  }

  /**
   * Generate key from title in camelCase with removed accents (like formio does)
   */
  public static generateGuideIdFromTitle(guideTitle: string) {
    if (guideTitle) {
      guideTitle = _.deburr(guideTitle);
      return _.camelCase(guideTitle);
    } else {
      throw new Error("Form title cannot be undefined!");
    }
  }

  public static updateWithVersion(comp: any) {
    comp.version = "201905";
    if (comp.components) {
      for (const child of comp.components) {
        this.updateWithVersion(child);
      }
    } else if (comp.rows && Array.isArray(comp.rows)) {
      for (const child of comp.rows) {
        if (child.components) {
          for (const entry of child.components) {
            this.updateWithVersion(entry);
          }
        } else if (Array.isArray(child)) {
          for (const item of child) {
              this.updateWithVersion(item);
            }
          }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        if (child.components) {
          for (const entry of child.components) {
            this.updateWithVersion(entry);
          }
        }
      }
    }
  }

  // when saving a table inside editgrid "numRows" and "numCols" disappear.
  public static updateTableAttributes(comp: any) {
    if (comp.components) {
      for (const child of comp.components) {
        this.updateTableAttributes(child);
      }
    } else if (Array.isArray(comp.rows)) {
      if (!comp.numRows) {
        comp.numRows = comp.rows.length;
      }
      if (!comp.numCols && comp.rows[0]) {
        comp.numCols = comp.rows[0].length;
      }
      for (const child of comp.rows) {
        for (const entry of child) {
          this.updateTableAttributes(entry);
        }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        this.updateTableAttributes(child);
      }
    }
  }

  public static updateServiceFieldsInSubComponents(comp: any, registrations: any[], refreshNeeded: boolean) {
    if (!comp.registrations) {
      comp.registrations = {};
    }
    if (registrations) {
      Object.keys(registrations).forEach((reg) => {
        if (registrations[reg] && !comp.registrations[reg]) {
          comp.registrations[reg] = true;
          refreshNeeded = true;
        }
      });
    }
    if (comp.components) {
      for (const child of comp.components) {
        refreshNeeded = this.updateServiceFieldsInSubComponents(child, comp.registrations, refreshNeeded);
      }
    } else if (comp.rows) {
      for (const child of comp.rows) {
        for (const entry of child) {
          refreshNeeded = this.updateServiceFieldsInSubComponents(entry, comp.registrations, refreshNeeded);
        }
      }
    } else if (comp.columns) {
      for (const child of comp.columns) {
        for (const entry of child) {
          refreshNeeded = this.updateServiceFieldsInSubComponents(entry, comp.registrations, refreshNeeded);
        }
      }
    }
    return refreshNeeded;
  }

}
